module.exports = __webpack_public_path__ + "img/pending.035c8043.svg";